import React from 'react';
import {TextContent} from "./TextContent";
import {SVGQuestionCircle} from "../../assets/svg/SVGQuestionCircle";

export function IntegratedTest(props) {


    return (

        <div className={"my-3"}>

            {
                props.children.length === 1 ?
                    <h6 className={"text-muted"}>Fått det med deg?</h6>
                :
                    null
            }

            {
                props.children.map(question => (

                    <div className={"rounded border border-2 border-dark p-0  mb-5"}>
                        <div className={"bg-primary text-white m-0 p-3 d-flex justify-content-start align-items-center rounded-top border-bottom border-dark"}>
                            <span className={"me-3"}>
                                <SVGQuestionCircle size={36}/>
                            </span>
                            <TextContent value={question.text} level={4} noMargin={true}></TextContent>
                        </div>
                        <div>
                            <textarea className={"form-control rounded-0 border-0 border-bottom border-dark bg-neutral-3"} placeholder={"Skriv svaret ditt her..."} style={{height:"10vh"}}></textarea>
                        </div>
                        <button className={"btn btn-dark border-0 w-100 rounded-0 py-2 rounded-bottom"}>Sjekk svar</button>
                    </div>

                ))
            }
        </div>

    );


}